import React from 'react'

function Reports() {
    return (
        <div>
            <p>Page Under Development</p>
        </div>
    )
}

export default Reports
